/* Recruiting-only disclosure navigation. No dependencies or global menu handlers. */
if (!customElements.get('recruiting-header')) {
  customElements.define('recruiting-header', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.button = this.querySelector('[data-rh-toggle]');
      this.panel = this.querySelector('[data-rh-panel]');
      this.media = matchMedia(document.body.classList.contains('recruiting-reference') ? '(min-width: 900px)' : '(min-width: 1200px)');
      this.button.hidden = false;
      this.open = false;
      this.update = () => {
        this.panel.hidden = !this.media.matches && !this.open;
        this.button.setAttribute('aria-expanded', String(this.open));
        this.button.setAttribute('aria-label', this.open ? this.dataset.closeLabel : this.dataset.openLabel);
        this.querySelector('[data-rh-label]').textContent = this.open ? this.dataset.closeLabel : this.dataset.openLabel;
        this.button.querySelector('path').setAttribute('d', this.open ? 'M4 4l12 12M16 4L4 16' : 'M2 4h16M2 10h16M2 16h16');
        this.classList.toggle('rh-open', this.open);
      };
      this.close = (restoreFocus = false) => {
        this.open = false;
        this.querySelectorAll('details[open]').forEach(details => { details.open = false; });
        this.update();
        if (restoreFocus) this.button.focus();
      };
      this.button.addEventListener('click', () => { this.open = !this.open; this.update(); }, options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const dropdown = event.target.closest('details[open]');
        if (dropdown) {
          dropdown.open = false;
          dropdown.querySelector('summary').focus();
        } else if (this.open) this.close(true);
        event.stopPropagation();
      }, options);
      this.addEventListener('focusout', () => {
        setTimeout(() => {
          if (this.isConnected && !this.contains(document.activeElement)) this.close();
        }, 0);
      }, options);
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.close();
      }, options);
      this.panel.addEventListener('click', event => {
        if (event.target.closest('a') && !this.media.matches) this.close(true);
      }, options);
      this.media.addEventListener('change', () => {
        const active = document.activeElement;
        const focusInPanel = this.panel.contains(active);
        this.close();
        if (!this.media.matches && focusInPanel) this.button.focus();
        if (this.media.matches && active === this.button) this.querySelector('.rh-brand').focus();
      }, options);
      this.resizeObserver = new ResizeObserver(() => {
        // Measure only the top row: expanding navigation must not move the hero.
        const height = this.media.matches ? this.querySelector('[data-rh-row]').offsetHeight : Math.max(this.querySelector('.rh-brand').offsetHeight, this.button.offsetHeight) + 32;
        document.body.style.setProperty('--rh-height', `${height}px`);
      });
      this.resizeObserver.observe(this.querySelector('[data-rh-row]'));
      const updateSurface = () => this.classList.toggle('rh-scrolled', window.scrollY > 20);
      window.addEventListener('scroll', updateSurface, { ...options, passive: true });
      updateSurface();
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}
